import type { LeadsType } from "app/pages/sales-intelligence/modules/leads-search";
import type { ContactsSearchResultsRequestDto } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/dto";

import type { IContactsQueryFactory } from "./types";

const CONTACTS_TABLE_DATA_QUERY_KEY = "contacts-search-table";
const CONTACTS_SINGLE_QUERY_KEY = "contacts:single";

const baseTableData = (): readonly string[] => {
    return [CONTACTS_TABLE_DATA_QUERY_KEY];
};

export const contactsQueryKeys: IContactsQueryFactory = {
    getSingleContactInfo(contactId: string): readonly string[] {
        return [CONTACTS_SINGLE_QUERY_KEY, contactId];
    },
    baseTableData,
    tableData(sourceType?: LeadsType, dto?: ContactsSearchResultsRequestDto, modificator?: unknown[]): unknown[] {
        return [...baseTableData(), ...[...(modificator || []), sourceType, dto].filter(Boolean)];
    },
};
